import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_external_login_actions = _resolveComponent("external-login-actions")
  const _component_login_form = _resolveComponent("login-form")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "show-action-close": true,
    "is-visible": $options.isVisible,
    width: "narrow",
    title: _ctx.Resources.Account.LogInModalTitle,
    icon: "right-to-bracket",
    subtitle: $options.subtitle,
    onActionClose: $options.close,
    onOpen: $options.onOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_component_external_login_actions, {
        "return-url": $options.returnUrl,
        class: "_mb-3",
        onSuccess: $options.onSuccess
      }, null, 8 /* PROPS */, ["return-url", "onSuccess"]),
      _createVNode(_component_login_form, {
        "return-url": $options.returnUrl,
        onSuccess: $options.onSuccess
      }, null, 8 /* PROPS */, ["return-url", "onSuccess"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "title", "subtitle", "onActionClose", "onOpen"]))
}